import { render } from "./TemplateElement.vue?vue&type=template&id=2bbb6ea4&scoped=true"
import script from "./TemplateElement.vue?vue&type=script&lang=js"
export * from "./TemplateElement.vue?vue&type=script&lang=js"

import "./TemplateElement.vue?vue&type=style&index=0&id=2bbb6ea4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bbb6ea4"]])

export default __exports__